import * as React from 'react';

import {EngagementPill} from 'shells/acorn-pill/svg/engagement';
import {MarketingPill} from 'shells/acorn-pill/svg/marketing';
import {SalesPill} from 'shells/acorn-pill/svg/sales';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

type Props = {
    suite: 'sales' | 'marketing' | 'engagement';
};

export function SuiteTitle(props: Props) {
    return (
        <>
            {props.suite === 'sales' && (
                <StackLegacy spacing={0}>
                    <SalesPill width={210} height={24} />
                    <Body size='small' color='dark'>
                        Select your Sales plan
                    </Body>
                </StackLegacy>
            )}
            {props.suite === 'marketing' && (
                <StackLegacy spacing={0}>
                    <MarketingPill width={263} height={27} />
                    <Body size='small' color='dark'>
                        Select your Marketing plan
                    </Body>
                </StackLegacy>
            )}
            {props.suite === 'engagement' && (
                <StackLegacy spacing={0}>
                    <EngagementPill width={293} height={27} />
                    <Body size='small' color='dark'>
                        Select your Engagement plan
                    </Body>
                </StackLegacy>
            )}
        </>
    );
}
